const SignaturePad = require('signature_pad/dist/signature_pad.umd.js');
const canvas = document.querySelector('canvas#signature');

let signaturePad = null;

if(canvas) {
    const ratio =  window.devicePixelRatio || 2;
    // canvas.style.width = canvas.parentNode.offsetWidth * ratio;
    // canvas.height = Math.floor(canvas.offsetWidth / 2 ) * ratio;
    // canvas.getContext("2d").scale(ratio, ratio);

    signaturePad = new SignaturePad(canvas);


    const input = document.getElementById('signature');
    if(input) {
        if (input.value) {
            signaturePad.fromDataURL(input.value);
        }
    }

}


function clearCurrentSignature() {
    const btnClear = document.getElementById('btn_reset_signature');
    if (btnClear) {
        btnClear.onclick = (e) => {
            if(canvas) signaturePad.clear();
            return false;
        };
    }
}

export function getCurrentSignature() {
    if (canvas && !signaturePad.isEmpty()) {
        const dataSignature = signaturePad.toDataURL('image/png');
        return dataSignature;
    }
    return null;
}

clearCurrentSignature();
